export const getFormDataByEmailaddress = async (emailAddress: string) => {
	return await fetch(`/Umbraco/Api/DonateForm/GetDonorDataCheck?emailAddress=${emailAddress}`, {
		method: "GET",
	})
		.then((resp) => resp.json())
		.then((data) => {
			return data;
		});
};
